import {
  IdCard,
  CreditCard,
  Receipt,
  Camera,
  Home,
  Briefcase,
} from "lucide-react";
import Reveal from "@/components/Reveal";

const DOCS = [
  { icon: IdCard, k: "Aadhar Card", v: "Identity proof" },
  { icon: CreditCard, k: "PAN Card", v: "Tax identifier" },
  { icon: Receipt, k: "Bank Statement", v: "Last 12 months" },
  { icon: Camera, k: "Passport Photo", v: "Recent · 2 copies" },
  { icon: Home, k: "Address Proof", v: "Utility / rent / Aadhar" },
  { icon: Briefcase, k: "Income Proof", v: "Optional · if available" },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works"
      className="relative bg-[#FAF6EC] text-[#0C1530] py-24 md:py-32 overflow-hidden"
    >
      <div className="pointer-events-none absolute top-0 right-0 w-[420px] h-[420px] rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 w-[380px] h-[380px] rounded-full bg-[#0F6B3D]/8 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase text-[#B68F1E]">
              · Easy documentation ·
            </span>
            <h2
              data-testid="documents-heading"
              className="font-display text-[40px] md:text-[60px] mt-5 leading-[1.05] tracking-tight"
            >
              Documents <em className="not-italic text-[#B68F1E]">required</em>
            </h2>
            <p className="mt-4 text-[#0C1530]/70 max-w-2xl mx-auto">
              Easy process · Minimum documentation · Quick approval · Flexible repayment — it&apos;s
              that simple.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {DOCS.map(({ icon: Icon, k, v }, i) => (
            <Reveal key={k} delay={i * 60}>
              <div
                data-testid={`doc-${k.toLowerCase().replace(/\s+/g, "-")}`}
                className="rounded-2xl p-5 bg-white border border-[#0A1F44]/10 hover:border-[#D4AF37]/60 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="w-10 h-10 rounded-md grid place-items-center bg-[#0F6B3D]/15 text-[#0F6B3D] border border-[#0F6B3D]/30">
                  <Icon size={18} />
                </span>
                <div className="mt-3 font-display text-base text-[#0A1F44]">{k}</div>
                <div className="mt-1 text-[#0C1530]/60 text-xs leading-snug">{v}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={400}>
          <p
            data-testid="documents-note"
            className="mt-8 text-center text-[#0C1530]/60 text-sm"
          >
            That&apos;s it. No CIBIL score, no salary slip needed for most products.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
